import {useAppContext} from "./useAppContext";
import {useFragment} from "@apollo/client";
import {RATING_PAGINATION_FRAGMENT} from "../definitions/fragments";
import {ItemClassificationType} from "../definitions/enums";
import {ProductRatingsModel} from "../models/view/productRatingsModel";
import {RatingType} from "../definitions/types";
import {useMemo} from "react";

export const useProductRatingPaginationFragment = () => {
    const {productId, primaryId} = useAppContext();

    const {complete, data} = useFragment({
        fragment: RATING_PAGINATION_FRAGMENT,
        fragmentName: "RatingPaginationFragment",
        from: {
            __typename: "RatingPagination",
            id: primaryId ?? productId,
            type: primaryId ? ItemClassificationType.Primary : ItemClassificationType.Standalone
        }
    });

    const model = useMemo(() => complete && data.ratings && data.pageInfo ?
        new ProductRatingsModel(productId, data.ratings as RatingType[], data.pageInfo) :
        new ProductRatingsModel(productId, [], null), [complete, data, productId]);

    return {model};
}